<template>
    <footer class="mt-auto py-5">
        <div class="container mt-1 mb-4 mt-md-3">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
                    <div class="text-center"></div>
                    <div class="d-block d-md-flex justify-content-between">
                        <div class="text-black-50 mb-5 mb-md-0 d-flex justify-content-center align-items-center">
                            <div>
                                <i class="ri-copyright-line top-plus-2 copyright mr-2"></i>{{ new Date().getFullYear() }}
                                <a :href="universityUrl" target="blank" class="text-black-50">
                                    {{ universityName }}
                                </a>
                            </div>
                            <span class="mx-3 smaller text-black-25 align-bottom" v-if="universityPhoneNumber">&#124;</span>
                            <div v-if="universityPhoneNumber">
                                <a :href="'tel:' + universityPhoneNumber.replace(/\s+/g, '')" class="text-black-50">{{ universityPhoneNumber }}</a>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center">
                            <i class="ri-xl text-black-25 ml-3 h-40 d-flex align-items-center cursor-pointer ri-secure-payment-line" v-b-popover.hover.top="'3D Secure'"></i>
                            <i class="ri-xl text-black-25 ml-3 h-40 d-flex align-items-center cursor-pointer ri-lock-line" v-b-popover.hover.top="'SSL'"></i>
                            <i class="ri-xl text-black-25 ml-3 h-40 d-flex align-items-center cursor-pointer ri-mastercard-fill" v-b-popover.hover.top="'Mastercard'"></i>
                            <i class="ri-2x text-black-25 ml-3 h-40 d-flex align-items-center cursor-pointer ri-visa-line" v-b-popover.hover.top="'Visa'"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>

import qs from "qs";
import ConstantService from "@/services/ConstantService";

export default {
    data() {
        return {
            universityName: null,
            universityPhoneNumber: null,
            universityUrl: null
        }
    },
    created() {
        this.getUName()
        this.getUPhone()
        this.getUUrl()
    },
    methods: {
        getUUrl(){
            const config = {
                params: {
                    key: 'university.web'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };
            ConstantService.getValue(config).then(response => {
                this.universityUrl = response.data.data;
            }).catch(e => {
                console.error("Error fetching data:", e);
            })
        },
        getUName() {
            const config = {
                params: {
                    key: this.getLocaleField('university.name')
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };
            ConstantService.getValue(config).then(response => {
                this.universityName = response.data.data;
            }).catch(e => {
                console.error("Error fetching data:", e);
            })
        },
        getUPhone() {
            const config = {
                params: {
                    key: 'university.phone_number'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };
            ConstantService.getValue(config).then(response => {
                this.universityPhoneNumber = response.data.data;
            }).catch(e => {
                console.error("Error fetching phone number:", e);
            })
        },
    }
}
</script>
